// extracted by mini-css-extract-plugin
module.exports = {"discount-description":"DiscountItems_discount-description__34h_o"};